import 'aos/dist/aos.css';
import './styles.scss';
import '../../partials/Layout/scripts';
import '../Header/scripts';
import '../Copyright/scripts';
import '../ModalNewsletter/scripts';
import '../Awards/scripts';

import lazyload from 'lazyload';
// import inlineSVG from 'inline-svg';
import smoothscroll from 'smoothscroll-polyfill';
import Inputmask from 'inputmask';
import { Modal, } from '../../assets/js/modal';

import AOS from 'aos';

smoothscroll.polyfill();

new lazyload(document.querySelectorAll('img',),);
Inputmask().mask(document.querySelectorAll('input',),);

// inlineSVG.init({
//   svgSelector: 'img.svg',
//   initClass: 'js-inlinesvg',
// }, function () {
//   console.log('All SVGs inlined',);
// },);


AOS.init({
  duration: 3000,
  once: true,
},);

Modal();

// nav-menu
const navMenu = document.getElementById('nav-menu',);
const navCloseBtn = document.getElementsByClassName('nav-close-btn',)[0];
const hamburgerMenu = document.getElementsByClassName('hamburger',)[0];

if (navMenu && hamburgerMenu) {
  hamburgerMenu.addEventListener('click', () => {
    navMenu.classList.toggle('is-active',);
  },);

  navCloseBtn.addEventListener('click', () => {
    navMenu.classList.remove('is-active',);
  },);
}
